/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_Up_SubtitleInputs */

const en_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start selling in minutes`)
};

const es_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza a vender en minutos`)
};

const fr_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencez à vendre en quelques minutes`)
};

const de_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte in Minuten mit dem Verkaufen`)
};

const ja_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数分で販売を開始`)
};

const zh_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`几分钟内开始您的销售`)
};

const ar_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ البيع في دقائق`)
};

const id_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai berjualan dalam hitungan menit`)
};

const it_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia a vendere in pochi minuti`)
};

const ru_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начните продавать за считанные минуты`)
};

const pt_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece a vender em minutos`)
};

const ko_auth_sign_up_subtitle = /** @type {(inputs: Auth_Sign_Up_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`몇 분 만에 판매를 시작하세요`)
};

/**
* | output |
* | --- |
* | "Start selling in minutes" |
*
* @param {Auth_Sign_Up_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_sign_up_subtitle = /** @type {((inputs?: Auth_Sign_Up_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_Up_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_sign_up_subtitle(inputs)
	if (locale === "es") return es_auth_sign_up_subtitle(inputs)
	if (locale === "fr") return fr_auth_sign_up_subtitle(inputs)
	if (locale === "de") return de_auth_sign_up_subtitle(inputs)
	if (locale === "ja") return ja_auth_sign_up_subtitle(inputs)
	if (locale === "zh") return zh_auth_sign_up_subtitle(inputs)
	if (locale === "ar") return ar_auth_sign_up_subtitle(inputs)
	if (locale === "id") return id_auth_sign_up_subtitle(inputs)
	if (locale === "it") return it_auth_sign_up_subtitle(inputs)
	if (locale === "ru") return ru_auth_sign_up_subtitle(inputs)
	if (locale === "pt") return pt_auth_sign_up_subtitle(inputs)
	return ko_auth_sign_up_subtitle(inputs)
});